import { Stack, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useGroupRules, UserGroupRules } from 'src/graphql';
import { DtoolsIntegrationView } from './dtools/dtools-integration-view';
import { PortalioIntegrationView } from './portalio/portalio-integration-view';
import { IntegrationsCardsContainer, IntegrationsCardsScrollArea } from './styled';

export const IntegrationsCardsTab = () => {
  const theme = useTheme();
  const { checkValidity, loading: loadingGroupRules } = useGroupRules();
  const allowDtoolsIntegration =
    !loadingGroupRules && checkValidity([UserGroupRules.AccessToDtoolsImportTool]);

  return (
    <Stack spacing={2} sx={{ overflow: 'hidden', height: '100%' }}>
      <IntegrationsCardsScrollArea>
        <IntegrationsCardsContainer container spacing={4} sx={{ margin: theme.spacing(2) }}>
          <Grid size={3}>
            <PortalioIntegrationView />
          </Grid>
          {allowDtoolsIntegration ? (
            <Grid size={3}>
              <DtoolsIntegrationView />
            </Grid>
          ) : null}
        </IntegrationsCardsContainer>
      </IntegrationsCardsScrollArea>
    </Stack>
  );
};
